var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"click":_vm.select}},[_vm._t("default")],2),_c('input',{ref:"inputFile",attrs:{"multiple":_vm.multiple,"type":"file","accept":_vm.accept},on:{"change":_vm.selectFile}})])
}
var staticRenderFns = []

export { render, staticRenderFns }